import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {ROUTE} from '@/constants/main/route';
import {useEvaluateInquiry} from './useEvaluateInquiry';
import {useGetInquiryInfo} from './useGetInquiryInfo';

export type SurveyForm = {
  feedback: number;
  speed: number;
};

interface UseSurveyFormProps {
  onSuccess: () => void;
  inquiryId: string;
}

export const useSurveyForm = ({onSuccess, inquiryId}: UseSurveyFormProps) => {
  // 문의 정보 조회
  const {data, isFetched} = useGetInquiryInfo({
    inquiryId,
  });
  const {isMember, isObjection} = data || {};
  const navigate = useNavigate();

  useEffect(() => {
    if (isFetched) {
      if (isObjection) {
        alert('이의제기는 만족도 평가를 제공하고 있지 않습니다.');
        navigate(ROUTE.INDEX);
      }
    }
  }, [isFetched]);

  // 만족도 평가 폼
  const [surveyForm, setSurveyForm] = useState<SurveyForm>({
    feedback: 0,
    speed: 0,
  });

  const isSubmitActive = surveyForm.speed > 0 && surveyForm.feedback > 0;

  // 만족도 평가 요청
  const {mutate} = useEvaluateInquiry({onSuccess});
  const evaluateInquiry = () => {
    if (!inquiryId || Object.values(surveyForm).every((value) => value === 0)) {
      return;
    }

    mutate({inquiryId, surveyForm, isMember});
  };

  return {surveyForm, setSurveyForm, evaluateInquiry, isSubmitActive};
};
